/**
 * Component: Button
 * Slug: button
 */

function setDropdownState(dropdown, isOpen) {
	const toggle = dropdown.querySelector(".share-dropdown-toggle");
	const menu = dropdown.querySelector(".share-dropdown-menu");

	window.clearTimeout(dropdown.shareCloseTimer);
	toggle.setAttribute("aria-expanded", String(isOpen));

	if (isOpen) {
		dropdown.classList.remove("is-closing");
		dropdown.classList.add("is-open");
		menu.hidden = false;
		return;
	}

	if (menu.hidden) return;

	dropdown.classList.remove("is-open");
	dropdown.classList.add("is-closing");
	const closeDelay = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 180;
	dropdown.shareCloseTimer = window.setTimeout(() => {
		dropdown.classList.remove("is-closing");
		menu.hidden = true;
	}, closeDelay);
}

document.addEventListener("click", (e) => {
	const toggle = e.target.closest(".share-dropdown-toggle");
	const currentDropdown = e.target.closest(".share-dropdown");

	document.querySelectorAll(".share-dropdown.is-open").forEach((dropdown) => {
		if (dropdown !== currentDropdown) setDropdownState(dropdown, false);
	});

	if (toggle) {
		const dropdown = toggle.closest(".share-dropdown");
		setDropdownState(dropdown, !dropdown.classList.contains("is-open"));
	}
});

document.addEventListener("keydown", (e) => {
	if (e.key !== "Escape") return;

	document.querySelectorAll(".share-dropdown.is-open").forEach((dropdown) => {
		setDropdownState(dropdown, false);
		dropdown.querySelector(".share-dropdown-toggle").focus();
	});
});
